import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { useStyledBlock, StyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";

type DividerProps = { color?: string; thickness?: number };

export function DividerBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<DividerProps>();

  if (tab === "content") {
    return (
      <div className="space-y-3">
        <div className="space-y-1">
          <Label className="text-xs">Color</Label>
          <Input
            type="color"
            className="h-8 w-full cursor-pointer p-1"
            value={props.color ?? "#e5e0d8"}
            onChange={(e) => setProp((p) => { p.color = e.target.value; })}
          />
        </div>
        <div className="space-y-1">
          <Label className="text-xs">Thickness ({props.thickness ?? 1}px)</Label>
          <Slider
            value={[props.thickness ?? 1]}
            max={8}
            step={1}
            onValueChange={([v]) => setProp((p) => { p.thickness = v; })}
          />
        </div>
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} showBackground={false} />;
  }
  return null;
}
